import { useEffect, useRef, useState } from 'react';

export default function PlaceMap({ id, location }) {
  const containerRef = useRef(null);
  const mapID = "map_" + id;
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: '100px' }
    );

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!isVisible) return;

    if (typeof window.createMap === 'function') {
      window.createMap(
        mapID,
        location[0],
        location[1],
        process.env.REACT_APP_CARTO_API_KEY
      );
    } else {
      console.warn('createMap is not defined');
    }
  }, [isVisible, mapID, location]);

  return (
    <div
      id={mapID}
      ref={containerRef}
      style={{ height: '180px', borderRadius: 15 }}
    />
  );
}
